import PropTypes from "prop-types"
import React, { useEffect, useState, useMemo, useCallback, useContext } from "react"
import { Input, Badge } from "reactstrap"

import { Link, useNavigate, useParams } from "react-router-dom"

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/TableContainer';
import { withTranslation } from "react-i18next";

import { get } from "helpers/api_helper";
import { checkScope } from "helpers/utility_helper";
import "../../components/Common/datatables.scss"
import Spinners from "components/Common/Spinner";
import { DeleteLanguageSetting, PatchLanguageSetting, SearchLanguageSetting } from "services/api/module/LanguageSetting";

import ModalContext from "../../contexts/ModalContext";
import moment from "moment";
import InputSwitch from "components/Input/InputSwitch";
import fn_helper from "helpers/fn_helper";
import Error401 from "components/Error401";

const RowStatus = fn_helper.TABLE.RowStatus;

const _routeLink = `language/setting`;
const _routePermission = `language:setting`

const LanguageSettingList = props => {
    // POPUP
    const { mAlert } = useContext(ModalContext);

    // OTHER STATE
    const qParams = useParams()
    const qLang = _.upperCase(qParams?.lang) ?? 'TH'
    const navigate = useNavigate();

    // LOCAL STATE
    const [contentList, setContentList] = useState([])
    const [contentListLoading, setContentListLoading] = useState(false)
    const [selectedContentId, setSelectedContentId] = useState([])


    const onDeleteRow = (ids = [], name = '') => {
        // alert('onDeleteRow'+ JSON.stringify(ids))
        mAlert.info({
            type: "confrim",
            title: "Alert Confrim",
            subTitle: `Are you sure Delete ${name} ?`,
            mode: "red",
            content: "",
            onClose: () => {},
            onYes: () => { 
                const payload = { mainIds: ids};
                API.fetchDeleteContentList(payload)
            },
            onNo: () => { console.log("Cancel") },
        })
    }

    const onPatchRow = (id = 0, fieldName = '', value = null) => {
        const payload = { id: id, fieldName: fieldName, value: value };
        API.fetchPatchContent(payload)
    }

    const onSelectionChange = fn_helper.TABLE.onSelectionChange;

    const columns = useMemo(
        () => [
            // {
            //     id: "colcheckbox",
            //     header: (cellProps) => {
            //         const row = cellProps?.row?.original
            //         return (
            //             <div style={{ display: "flex", justifyContent: "center" }}>
            //                 <Input 
            //                     type={`checkbox`} 
            //                     checked={ contentList.length === 0 ? false : contentList.length === selectedContentId.length}
            //                     onClick={() => {
            //                         let updateData = onSelectionChange(row, selectedContentId, contentList, "all")
            //                         console.log("🚀 ~ LanguageSettingList ~ updateData:", updateData)
            //                         setSelectedContentId(updateData)
            //                     }}
            //                     readOnly
            //                 />
            //             </div>
            //     )},
            //     enableColumnFilter: false,
            //     enableSorting: false,
            //     cell: (cellProps) => {
            //         const row = cellProps?.row?.original
            //         return (
            //             <>
            //                 <div id={cellProps.row.id} style={{ display: "flex", justifyContent: "center" }}>
            //                     <Input 
            //                         type={`checkbox`} 
            //                         checked={selectedContentId.includes(row.mainId)} 
            //                         onClick={() => {
            //                             let updateData = onSelectionChange(row, selectedContentId, contentList)
            //                             setSelectedContentId(updateData)
            //                         }}
            //                         readOnly
            //                     />
            //                 </div>
            //             </>
            //         )
            //     }
            // },
            // {
            //     header: '#No.',
            //     accessorKey: 'sequence',
            //     enableColumnFilter: false,
            //     enableSorting: true,
            //     cell: (cellProps) => {
            //         const row = cellProps?.row?.original
            //         return (
            //             <>
            //                 <div style={{ display: "flex", justifyContent: "left" }}>
            //                     { row.sequence }
            //                 </div>
            //             </>
            //         )
            //     }
            // },
            {
                header: 'Lang',
                enableSorting: true,
                cell: (cellProps) => {
                    const { id, langFlag, langKey, langName } = cellProps.row.original
                    return (
                        <div className="flag-box">
                            <img style={{ width: '45px', height: '30px'}} src={langFlag}/>
                            <p>{langName} ({langKey})</p>
                        </div>
                    )
                }
            },
            // {
            //     header: 'Tools',
            //     accessorKey: 'user_id',
            //     enableColumnFilter: false,
            //     enableSorting: false,
            //     cell: (cellProps) => {
            //         let { mainId, platformName } = cellProps?.row?.original ?? {};
            //         const id = mainId
            //         return (
            //             <>
            //                 {checkScope(`${_routePermission}:view`) && <Link className={`btn btn-info`} to={`/${_routeLink}/${qLang}/view/${id}`}><i className={`bx bx-show-alt`}></i></Link>}
            //                 &nbsp;
            //                 {checkScope(`${_routePermission}:update`) && <Link className={`btn btn-warning`} to={`/${_routeLink}/${qLang}/edit/${id}`}><i className={`bx bx-edit-alt`}></i></Link>}
            //                 &nbsp;
            //                 {checkScope(`${_routePermission}:delete`) && <a className={`btn btn-danger`} onClick={() => onDeleteRow([id], platformName)}><i className={`bx bx-trash`}></i></a>}
            //             </>
            //         )
            //     }
            // },
        ],
        [selectedContentId, contentList]
    );

    const API = {
        fetchContentList: async () => {
            try {
                const response = await SearchLanguageSetting({ lang: qLang })
                const resData = response?.data ?? []
                setContentList(resData.data);
            } catch (e) {
                console.log(e)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                    //  alert("onClose")
                    },
                })
            } finally {
                setContentListLoading(false)
            }
        },
        fetchPatchContent: async (payload) => {
            try {
                const response = await PatchLanguageSetting({ data: payload, id: payload.id, lang: qLang })
                const resData = response.data
                if (resData.status === 202) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Update Data Success",
                        content: "",
                        onClose: () => {
                            fetchAPI()
                        },
                    })
                }
            }
            catch (err) {
                console.log('err ', err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                    //  alert("onClose")
                    },
                })
            }
        },
        fetchDeleteContentList: async (payload) => {
            try {
                const response = await DeleteLanguageSetting({ data: payload, lang: qLang })
                const resData = response.data
                if (resData.status === 202) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Delete Data Success",
                        content: "",
                        onClose: () => {
                            fetchAPI()
                        },
                    })
                }
            }
            catch (err) {
                console.log('err ', err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                    //  alert("onClose")
                    },
                })
            }
        }
        
    }

    const fetchAPI = () => {
        const payload = {}
        API.fetchContentList(payload)
    }

    useEffect(() => {
        setContentListLoading(true)
        fetchAPI()
    }, [qLang]);

    useEffect(() => {
        if (contentList.length) {
            setContentListLoading(false)
        }
    }, [contentList])

    //meta title
    document.title = "Language Setting | " + process.env.REACT_APP_CMS_TITLE;

    if(!checkScope(`${_routePermission}:list`)) {
        return <Error401 />
    }

    return (
        <div className="page-content">
            <div className="container-fluid">
                <Breadcrumbs title="Language Setting" breadcrumbItem="Language Setting List" />
                <TableContainer
                    isAddButton={false}
                    addRowLink={`/create`}
                    columns={columns}
                    data={contentList || []}
                    isGlobalFilter={true}
                    isPagination={true}
                    SearchPlaceholder="Search"
                    pagination="pagination"
                    paginationWrapper='dataTables_paginate paging_simple_numbers'
                    tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                    theadClass="table-light"
                    rootMenu="systemsettings"
                    subMenu="usersetting"
                    isCustomPageSize={true}
                    isSelected={selectedContentId.length > 0}
                    onClearSelected={() => setSelectedContentId([])}
                    onDeleleSelected={() => onDeleteRow(_.cloneDeep(selectedContentId))}
                    isExportButton={true}
                    exportOption={{
                        filename: "brand-platform",
                        dateColumns: []
                    }}
                    routePermission={_routePermission}
                    sortTable={{
                        tableName: 'language',
                        fetchCallBack: () => {
                            setContentListLoading(true)
                            fetchAPI()
                        }
                    }}
                    langSwitch={false}
                    actionBar={false}
                />
            </div>
        </div>
    );
}

LanguageSettingList.propTypes = {
    t: PropTypes.any,
}

export default withTranslation()(LanguageSettingList)
